import { useMemo } from 'react';
import { Column } from '@plasma/ui.display.data-grid';

export type UserDataDisplayType = {
  Username: string;
  RoleId: string;
  Comapany: string;
  EmployeeId: string;
  GroupId: string;
  Contactnumber: string;
  Email: string;
};

export type UsersDataType = {
  companyid: string;
  contactno: null | string;
  email: string;
  employeeid: string;
  groupid: null | string;
  id: string;
  sessionid: string;
  isactive: boolean;
  mop: string;
  remarks: null | string;
  resetpassword: number;
  roleid: number;
  toc: string;
  tom: string;
  username: string;
};
export type companysDataType = {
  id: string;
  displayseq: number;
  areacode: string;
  zonecode: string;
  equipment: string;
  positionnumber: number;
  consumablecode: string;
  quantityinstalled: number;
  drawingnumber: string | null;
  isactive: boolean;
  remarks: string;
  toc: null | string;
  tom: null | string;
  mop: null | string;
};

export type UserInfoKeyCloak = {
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  name: string;
  preferred_username: string;
  sub: string;
  roleid: string;
};

function ExportUserColumns(): Column<UsersDataType>[] {
  const UserColumns = useMemo<Column<UsersDataType>[]>(
    () => [
      {
        Header: 'Company ID',
        accessor: 'companyid',
      },
      {
        Header: 'Employee ID',
        accessor: 'employeeid',
      },

      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Username',
        accessor: 'username',
      },
      {
        Header: 'Contact Number',
        accessor: 'contactno',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Role ID',
        accessor: 'roleid',
      },
      {
        Header: 'Group ID',
        accessor: 'groupid',
      },
      {
        Header: 'Is Active',
        accessor: 'isactive',
      },
      {
        Header: 'MOP',
        accessor: 'mop',
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
      },
      {
        Header: 'Reset Password',
        accessor: 'resetpassword',
      },

      {
        Header: 'TOC',
        accessor: 'toc',
      },
      {
        Header: 'TOM',
        accessor: 'tom',
      },
    ],
    [],
  );

  return UserColumns;
}

export default ExportUserColumns;
